import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { HighlightLinkComponent } from './svg/highlight-link.component';

/**
 * Ebo = Einbauort ?!
 * We think that this info is a pointer into the wiring diagram
 * (rather than a link to another article).
 * So, we hide it for now, as a SVG link is a big effort and
 * the SVGs are not very good currently.
 */
@Component({
  selector: 'app-vw-ebo-link',
  imports: [CommonModule, HighlightLinkComponent],
  standalone: true,
  template: `
    <app-highlight-link
      [componentIdWithinImage]="componentIdWithinImage()"
      elClass="text-blue-500"
      activeClass="text-blue-700 scale-125"
      unavailableClass="hidden">
      <i class="pi pi-eye !text-sm"></i>
    </app-highlight-link>
  `,
})
export class EboLinkComponent extends XMLElementBaseComponent<any> {
  componentIdWithinImage = computed(() => {
    const ziel = this.data?.ziel;
    return typeof ziel === 'string' ? ziel.replace(/^BT/, '') : undefined;
  });
}
